import styled from 'styled-components';
import {
  DESKTOP_VERTICAL_PADDING,
  MAX_PAGE_CONTENT_WIDTH,
  MOBILE_VERTICAL_PADDING,
} from '../../../styles/Layout';
import { ThemeColours } from '../../../styles/ThemeColours';
import { Breakpoint } from '../../../styles/constants';
import { responsiveInterpolate } from '../../../styles/responsiveInterpolate';

export const PageSectionWrapper = styled.div`
  background-color: ${ThemeColours.white};
  display: flex;
  height: auto;
  justify-content: center;
  position: relative;
`;

export const PageSectionContainer = styled.div<{ topNavExperiment?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  max-width: ${MAX_PAGE_CONTENT_WIDTH}px;
  padding: ${responsiveInterpolate(MOBILE_VERTICAL_PADDING, DESKTOP_VERTICAL_PADDING)} 20px;

  ${({ topNavExperiment }) =>
    topNavExperiment &&
    `
      ${Breakpoint.MEDIUM} {
        padding: ${responsiveInterpolate(
          MOBILE_VERTICAL_PADDING,
          DESKTOP_VERTICAL_PADDING + 60,
        )} 20px;}
    `}
  position: relative;
`;

export const PageSectionContainerExperiment = styled(PageSectionContainer)`
  padding: ${responsiveInterpolate(MOBILE_VERTICAL_PADDING, DESKTOP_VERTICAL_PADDING)} 16px;
`;
